import { useUser } from "@clerk/clerk-react"
import { LayoutDashboard } from "lucide-react"
import React from "react"
import { Toaster } from "react-hot-toast"
import { BsCarFront, BsCashCoin } from "react-icons/bs"
import { FcAssistant, FcCustomerSupport, FcStatistics } from "react-icons/fc"
import { LuBriefcaseBusiness } from "react-icons/lu"
import { PiShareNetworkBold } from "react-icons/pi"
import { useLocation, useNavigate, useSearchParams } from "react-router-dom"
import DashboardContent from "../DashboardContent"
import NavbarDashboard from "../NavbarDashboard"
import Sidebar, {
  SidebarItem,
  SidebarItemWithSubMenu,
  SidebarTitle,
} from "../Sidebar"
import Spinner from "../Spinner"

export default function DashboardLayout(props: { children: React.ReactNode }) {
  const { isSignedIn, isLoaded } = useUser()
  const { pathname } = useLocation()
  const [searchParams] = useSearchParams()
  const navigate = useNavigate()

  const business = searchParams.get("business")

  if (!isLoaded) return <Spinner />

  if (isSignedIn === false) {
    navigate("/sign-in")
    return null // Return null to prevent rendering anything else.
  }

  return (
    <div className="flex relative overflow-y-hidden">
      <Toaster position="top-center" reverseOrder={false} />
      <Sidebar>
        <SidebarItem
          icon={<LayoutDashboard size={28} />}
          text="dashboard"
          path="/admin"
          active={pathname === "/admin/stats" && business === null}
        />
        <SidebarItem
          icon={<BsCarFront size={28} />}
          text="Todos los carros"
          path="/admin/carros/page/1"
          active={pathname.includes("/admin/carros/page") && business === null}
        />
        <SidebarItem
          icon={<LuBriefcaseBusiness size={28} />}
          text="Archivo"
          path="/admin/archivo/page/1"
          active={pathname.includes("/admin/archivo/page")}
        />
        <SidebarTitle
          titleTex="Unidades de Negocio"
          styles="flex justify-center items-center"
        />
        <SidebarTitle titleTex="Promoción" />
        <SidebarItemWithSubMenu
          icon={<PiShareNetworkBold size={30} />}
          text="Promoción"
          active={business === "promocion"}
          subItems={[
            {
              icon: FcStatistics,
              text: "Estadísticas",
              path: "/admin/stats?business=promocion",
            },
            {
              icon: "🧪",
              text: "Carros en Prueba",
              path: "/admin/carros/page/1?business=promocion&state=test",
            },
            {
              icon: "🚘",
              text: "Carros con Servicio",
              path: "/admin/carros/page/1?business=promocion&state=active",
            },
            {
              icon: FcAssistant,
              text: "Seguimiento 1",
              path: "/admin/carros/page/1?business=promocion&followup=1",
            },
            {
              icon: FcCustomerSupport,
              text: "Seguimiento 2",
              path: "/admin/carros/page/1?business=promocion&followup=2",
            },
          ]}
        />
        <SidebarTitle titleTex="Inversión" />
        <SidebarItemWithSubMenu
          icon={<BsCashCoin size={30} />}
          text="Inversión"
          active={business === "inversion"}
          subItems={[
            {
              icon: FcStatistics,
              text: "Estadísticas",
              path: "/admin/stats?business=inversion",
            },
            {
              icon: "🤑",
              text: "Carros de Inversión",
              path: "/admin/carros/page/1?business=inversion",
            },
          ]}
        />
      </Sidebar>
      <div className="flex flex-col w-full">
        <NavbarDashboard />
        <DashboardContent>{props.children}</DashboardContent>
      </div>
    </div>
  )
}
